import * as moment from 'moment';

export class DateUtils {

    static getCurrentDateTimeUTCString(): string {
        const now = moment().utc();
        return now.format();
    }
}
